import { FC, useRef } from 'react'
import { ScrollView, StyleProp, StyleSheet, View, ViewStyle } from 'react-native'
import { ColorsEnum } from '../../constants/colors'
import { IStationState, OrderStatesEnum } from '../../constants/order'
import { StationColumnIds } from '../../constants/stations'
import { useAppSelector } from '../../hooks/redux'
import { useFirebaseOrdersConnect } from '../../hooks/useFirebaseOrdersConnect'
import { stationSelectors } from '../../redux/reducers/station'
import { selectFilteredOrders } from '../../redux/reselectors/order'
import CustomerOrder from '../Order/CustomerOrder'
import ColumnTitle from '../UI/Columns/ColumnTitle'

interface CustomerOrderColumnProps {
    id: StationColumnIds
    stationStates?: IStationState[]
    states?: OrderStatesEnum[]
    title: string
    width: number
    style?: StyleProp<ViewStyle>
}

const CustomerOrderColumn: FC<CustomerOrderColumnProps> = ({
    id,
    stationStates,
    states,
    title,
    width,
    style,
}) => {
    const { code } = useAppSelector(stationSelectors.currentStation)!

    const orderReselectorRef = useRef(selectFilteredOrders(id, code, stationStates, states))

    const orders = useAppSelector(orderReselectorRef.current)

    useFirebaseOrdersConnect(stationStates, states)

    const isCustomerCookedColumn = id === StationColumnIds.CUSTOMER_COOKED

    return (
        <View style={[styles.outerContainer, { width }, style]}>
            <ColumnTitle style={styles.title}>{title}</ColumnTitle>
            <ScrollView showsVerticalScrollIndicator={false} contentContainerStyle={styles.innerContainer}>
                {orders?.map((order) => (
                    <CustomerOrder
                        key={order.orderKey}
                        code={order.code}
                        textColor={isCustomerCookedColumn && '#FFFFFF'}
                        color={isCustomerCookedColumn && ColorsEnum.SUCCESS}
                    />
                ))}
            </ScrollView>
        </View>
    )
}

const styles = StyleSheet.create({
    outerContainer: {
        backgroundColor: 'green',
    },
    innerContainer: {
        flexDirection: 'row',
        flexWrap: 'wrap',
    },
    title: {
        fontSize: 20,
        paddingVertical: 12,
        paddingHorizontal: 8,
    },
})

export default CustomerOrderColumn
